<template>
    <div
        id="lt-yantr"
        class="student-loan-payoff">
        <div class="tooltip-top-wrap blue-wrap-student">
            <div class="container">
                <div class="adv-disclosure-block">
                    <div class="adv-disclosure-inner">
                        <template v-if="ShowHdltgp">
                            <button
                                id="get-paid-btn"
                                class="tooltip-btn a11y-modal-trigger"
                                data-target="get-paid-tooltip">
                                {{ getPaidTitle }}
                            </button>
                            <div class="tooltip-box">
                                <tooltip-view
                                    :label="getPaidTitle"
                                    :show-on-over="ShowOnOver"
                                    :popper-content="getPaidDescription"
                                />
                            </div>
                        </template>
                        <advertising-disclosures
                            v-if="DisclosureText"
                            :disclosure-text="disclosureText"
                            :disclosure-tokens="disclosureTokens"
                            :open-disclosure-modal="openDisclosureModal"
                        />
                    </div>
                </div>
            </div>
        </div>
        <div class="student-loan-wrapper blue-wrap-student">
            <div class="container">
                <h2 class="student-payoff-block-title">
                    Student Loan Payoff Calculator
                </h2>
                <p class="student-payoff-block-description">
                    If you can swing it, paying off student loans ahead of schedule can be a smart way to save <br />thousands of your hard earned dollars.
                </p>
            </div>
        </div>
        <div class="student-calculation-outer">
            <div class="student-filter-wrapper">
                <div class="student-filter-inputs">
                    <form
                        ref="form"
                        @submit.prevent="studentLoanPayoffCalculation()">
                        <ul class="filter-block">
                            <li>
                                <number-input
                                    v-model="BalanceAmount"
                                    :label="labelBalanceAmount"
                                    :class="error.balanceAmountError ? 'error-border-red' : ''"
                                    :value="balanceAmount"
                                    input-name="balanceAmount"
                                    inputmode="decimal"
                                    maxlength="6"
                                    minvalue="1"
                                    :show-symbol="false"
                                    no-decimal="true">
                                    <template #leftimage>
                                        <div class="input-group-addon">
                                            <img src="../../assets/images/dollar-icon.svg" />
                                        </div>
                                    </template>
                                    <template #errormessage>
                                        <div class="error-text">
                                            <p v-if="error.balanceAmountError">
                                                {{ error.balanceAmountError }}
                                            </p>
                                        </div>
                                    </template>
                                </number-input>
                            </li>
                            <li>
                                <number-input
                                    v-model="AverageInterestRate"
                                    :label="labelAverageInterestRate"
                                    :class="error.averageInterestRateError ? 'error-border-red' : ''"
                                    precision="3"
                                    max-value="99.999"
                                    input-name="averageInterestRate"
                                    :value="averageInterestRate"
                                    :show-symbol="false"
                                    maxlength="5"
                                    minvalue="0"
                                    inputmode="decimal"
                                    @input="validateAverageInterestRate()">
                                    <template #rightimage>
                                        <div class="input-group-addon">
                                            <img src="../../assets/images/percentage-icon.svg" />
                                        </div>
                                    </template>
                                    <template #errormessage>
                                        <div class="error-text">
                                            <p v-if="error.averageInterestRateError">
                                                {{ error.averageInterestRateError }}
                                            </p>
                                        </div>
                                    </template>
                                </number-input>
                            </li>
                            <li>
                                <number-input
                                    v-model="LoanTerm"
                                    :label="labelLoanTerm"
                                    :class="error.loanTermError || error.properMonthlyPaymentAndLoanTerm || error.properMonthlyPayment ? 'error-border-red' : ''"
                                    input-name="loanTerm"
                                    maxlength="6"
                                    minvalue="1"
                                    inputmode="decimal"
                                    symbol="/mo"
                                    symbol-aligned="right"
                                    no-decimal="true">
                                    <template #leftimage>
                                        <div class="input-group-addon">
                                            <img src="../../assets/images/dollar-icon.svg" />
                                        </div>
                                    </template>
                                    <template #errormessage>
                                        <div class="error-text">
                                            <p v-if="error.properMonthlyPayment">
                                                {{ error.properMonthlyPayment }}
                                            </p>
                                            <p v-if="error.loanTermError">
                                                {{ error.loanTermError }}
                                            </p>
                                        </div>
                                    </template>
                                </number-input>
                            </li>
                            <li>
                                <label><strong>Select an option:</strong></label>
                                <br />
                                <div class="radio-section">
                                    <div class="pay-off-button">
                                        <input
                                            type="radio"
                                            name="yearPayment"
                                            :checked="showhideHowMuchMorePerMonthInput === 1 ? 'checked' : ''"
                                            @change="showHideInput(1)"
                                        /> Pay Extra
                                    </div>
                                    <div class="pay-off-button">
                                        <input
                                            type="radio"
                                            name="yearPayment"
                                            :checked="showhideHowMuchMorePerMonthInput === 0 ? 'checked' : ''"
                                            @change="showHideInput(0)"
                                        /> Years to pay off
                                    </div>
                                </div>
                            </li>
                            <li>
                                <div v-if="showhideHowMuchMorePerMonthInput === 1">
                                    <label for="morePerMonth">How much more per month?</label>
                                    <number-input
                                        v-model="MorePerMonth"
                                        precision="0"
                                        input-name="morePerMonth"
                                        inputmode="decimal"
                                        maxlength="6"
                                        minvalue="1"
                                        no-decimal="true"
                                        :show-symbol="false"
                                        :class="error.properMonthlyPaymentAndLoanTerm || error.monthPayExtraOrYearsToPayoffError ? 'error-border-red' : ''">
                                        <template #leftimage>
                                            <div class="input-group-addon">
                                                <img src="../../assets/images/dollar-icon.svg" />
                                            </div>
                                        </template>
                                        <template #errormessage>
                                            <div class="error-text">
                                                <p v-if="error.monthPayExtraOrYearsToPayoffError">
                                                    {{ error.monthPayExtraOrYearsToPayoffError }}
                                                </p>
                                            </div>
                                        </template>
                                    </number-input>
                                </div>
                                <div v-else>
                                    <label>How many years to pay off?</label>
                                    <number-input
                                        v-model="YearPayOff"
                                        precision="0"
                                        input-name="yearPayOff"
                                        inputmode="decimal"
                                        max-value="99"
                                        maxlength="2"
                                        minvalue="1"
                                        no-decimal="true"
                                        symbol="year(s)"
                                        symbol-aligned="right"
                                        :class="error.monthPayExtraOrYearsToPayoffError ? 'error-border-red' : ''">
                                        <template #errormessage>
                                            <div class="error-text">
                                                <p v-if="error.monthPayExtraOrYearsToPayoffError">
                                                    {{ error.monthPayExtraOrYearsToPayoffError }}
                                                </p>
                                            </div>
                                        </template>
                                    </number-input>
                                </div>
                            </li>
                            <li>
                                <div class="form-group">
                                    <div class="error-text">
                                        <p v-if="error.properMonthlyPaymentAndLoanTerm">
                                            {{ error.properMonthlyPaymentAndLoanTerm }}
                                        </p>
                                    </div>
                                </div>
                            </li>
                            <li class="text-center">
                                <button
                                    class="btn calculate-btn"
                                    type="submit">
                                    {{ calculationButtonText }}
                                </button>
                            </li>
                        </ul>
                    </form>
                </div>
            </div>
            <div class="student-result-wrapper">
                <calculation-result
                    v-if="showResult"
                    :show-result="showResult"
                    :original-loan="originalLoan"
                    :increased-payment="increasedPayment"
                    :show-advanced-options="showAdvancedOptions"
                />
                <default-result v-else />
            </div>
        </div>
        <a11y-modal
            v-if="ShowHdltgp"
            id="get-paid-tooltip">
            <template #h4>
                {{ getPaidTitle }}
            </template>
            <div slot="body">
                <div class="description">
                    <p> {{ getPaidDescription }} </p>
                </div>
            </div>
        </a11y-modal>
    </div>
</template>
<script>
    import Accounting from 'accounting';
    import AdvertisingDisclosures from '~/components/advertising-disclosures.vue';
    import tooltipView from '~/components/tooltip-view.vue';
    import NumberInput from '~/components/number-input.vue';
    import CalculationResult from './components/calculation-result.vue';
    import DefaultResult from './components/default-result.vue';
    import helperstudentloanpayoff from './helpers/studentloanpayoff';
    import a11yModal from '~/helpers/a11y-modal';
    import A11yModal from '~/components/a11y-modal.vue';

    export default {
        components: {
            AdvertisingDisclosures,
            tooltipView,
            CalculationResult,
            NumberInput,
            DefaultResult,
            A11yModal,
        },
        props: {
            averageInterestRate: {
                default: 4.99,
            },
            balanceAmount: {
                default: 30000,
            },
            calculationButtonText: {
                default: 'Calculate',
            },
            disclosureText: {
                default: 'Disclosures',
            },
            disclosureTokens: {
                default: '00001,00057,00058,00059,00099,101',
            },
            getPaidDescription: {
                default: 'LendingTree is compensated by companies on this site and this compensation may impact how and where offers appears on this site (such as the order). LendingTree does not include all lenders, savings products, or loan options available in the marketplace.',
            },
            getPaidTitle: {
                default: 'How Does LendingTree Get Paid?',
            },
            increasedPayment: {
                default: 'Inc. Payment',
            },
            labelAverageInterestRate: {
                default: 'Average Interest Rate',
            },
            labelBalanceAmount: {
                default: 'Student Loan Balance',
            },
            labelLoanTerm: {
                default: 'Current Monthly Payment',
            },
            loanTerm: {
                default: 318,
            },
            morePerMonth: {
                default: 150,
            },
            openDisclosureModal: {
                default: true,
            },
            originalLoan: {
                default: 'Org. Loan',
            },
            showAdvancedOptions: {
                default: false,
            },
            showOnOver: {
                default: true,
            },
            hideHdltgp: {
                default: false,
            },
            yearPayOff: {
                default: 5,
            },
            yearPayment: {
                default: 1,
            },
        },
        data() {
            return {
                DisclosureText: this.disclosureText,
                DisclosureTokens: this.disclosureTokens,
                ShowOnOver: this.showOnOver,
                ShowHdltgp: !this.hideHdltgp,
                AverageInterestRate: this.averageInterestRate,
                BalanceAmount: Accounting.format(this.balanceAmount),
                LoanTerm: Accounting.format(this.loanTerm),
                CalculationButtonText: this.calculationButtonText,
                YearPayOff: this.yearPayOff,
                MorePerMonth: Accounting.format(this.morePerMonth),
                showhideHowMuchMorePerMonthInput: this.yearPayment,
                showResult: '',
                error: {
                    balanceAmountError: '',
                    averageInterestRateError: '',
                    loanTermError: '',
                    monthPayExtraOrYearsToPayoffError: '',
                    properMonthlyPaymentAndLoanTerm: '',
                },
                errorMessages: {
                    balanceAmount: 'Student Loan Balance should be between $1 to $999,999',
                    averageInterestRate: 'Average Interest should be between 1 to 99.999%',
                    loanTerm: 'Current Monthly Payment should be between $1 to $999,999',
                    monthPayExtra: 'Monthly Pay Extra should be between $1 to $999,999',
                    yearPayOff: 'Years to Pay Off should be between 1 to 99',
                    higherLoanTerm: 'Please enter a higher monthly payment value',
                    properMonthlyPaymentAndLoanTerm: 'Please enter a proper monthly payment value and pay extra per month value',
                    properMonthlyPayment: 'Please enter a proper monthly payment value',
                },
            };
        },
        computed: {},
        mounted() {
            this.validateAverageInterestRate();
            this.showHideInput(this.showhideHowMuchMorePerMonthInput);
            setTimeout(() => {
                a11yModal.initModal();
            }, 1000);
        },
        methods: {
            validateAverageInterestRate() {
                this.AverageInterestRate = this.AverageInterestRate > 99.999 ? 99.999 : this.AverageInterestRate;
            },
            showHideInput(value) {
                this.showhideHowMuchMorePerMonthInput = value;
            },
            validationForStudentLoanPayoff(formData) {
                if (formData.balanceAmount < 1) {
                    this.error.balanceAmountError = this.errorMessages.balanceAmount;
                } else {
                    this.error.balanceAmountError = '';
                }
                if (formData.averageInterestRate > 99.999 || formData.averageInterestRate < 0 || formData.averageInterestRate === 0 || formData.averageInterestRate === '') {
                    this.error.averageInterestRateError = this.errorMessages.averageInterestRate;
                } else {
                    this.error.averageInterestRateError = '';
                }
                if (formData.loanTerm < 1) {
                    this.error.loanTermError = this.errorMessages.loanTerm;
                } else {
                    this.error.loanTermError = '';
                }
                if (this.showhideHowMuchMorePerMonthInput === 1) {
                    if (parseFloat(formData.morePerMonth) < 1) {
                        this.error.monthPayExtraOrYearsToPayoffError = this.errorMessages.monthPayExtra;
                    } else {
                        this.error.monthPayExtraOrYearsToPayoffError = '';
                    }
                    if (Accounting.unformat(formData.morePerMonth + formData.loanTerm) > formData.balanceAmount) {
                        this.error.properMonthlyPaymentAndLoanTerm = this.errorMessages.properMonthlyPaymentAndLoanTerm;
                        this.error.properMonthlyPayment = '';
                    } else {
                        this.error.properMonthlyPaymentAndLoanTerm = '';
                    }
                } else if (!this.showhideHowMuchMorePerMonthInput) {
                    if (formData.yearPayOff > 99 || formData.yearPayOff < 1) {
                        this.error.monthPayExtraOrYearsToPayoffError = this.errorMessages.yearPayOff;
                    } else {
                        this.error.monthPayExtraOrYearsToPayoffError = '';
                    }
                    if (Accounting.unformat(formData.loanTerm) > formData.balanceAmount) {
                        this.error.properMonthlyPayment = this.errorMessages.properMonthlyPayment;
                        this.error.properMonthlyPaymentAndLoanTerm = '';
                    } else {
                        this.error.properMonthlyPayment = '';
                    }
                }
            },
            getFormData() {
                this.BalanceAmount = Accounting.format(this.$refs.form.balanceAmount.value);
                this.AverageInterestRate = Accounting.formatMoney(this.$refs.form.averageInterestRate.value, { symbol: '', precision: 3 });
                this.LoanTerm = Accounting.format(this.$refs.form.loanTerm.value, { symbol: '', precision: 0 });
                if (this.showhideHowMuchMorePerMonthInput === 1) {
                    this.MorePerMonth = this.$refs.form.morePerMonth.value ? Accounting.format(this.$refs.form.morePerMonth.value, { symbol: '', precision: 0 }) : '';
                } else {
                    this.YearPayOff = this.$refs.form.yearPayOff.value ? Accounting.format(this.$refs.form.yearPayOff.value, { symbol: '', precision: 0 }) : '';
                }
                return {
                    balanceAmount: Math.round(Accounting.unformat(this.$refs.form.balanceAmount.value)),
                    averageInterestRate: parseFloat(Accounting.unformat(this.$refs.form.averageInterestRate.value)),
                    loanTerm: Math.round(Accounting.unformat(this.$refs.form.loanTerm.value)),
                    morePerMonth: this.showhideHowMuchMorePerMonthInput === 1 ? Math.round(Accounting.unformat(this.$refs.form.morePerMonth.value)) : '',
                    yearPayOff: !this.showhideHowMuchMorePerMonthInput ? Accounting.unformat(this.$refs.form.yearPayOff.value) : '',
                };
            },
            isValidForm() {
                return !this.error.balanceAmountError
                    && !this.error.averageInterestRateError
                    && !this.error.loanTermError
                    && !this.error.monthPayExtraOrYearsToPayoffError
                    && !this.error.properMonthlyPaymentAndLoanTerm
                    && !this.error.properMonthlyPayment;
            },
            studentLoanPayoffCalculation() {
                const formData = this.getFormData();
                this.validationForStudentLoanPayoff(formData);
                if (this.isValidForm()) {
                    let monthlyPayment = 0.00;
                    let timeline = 0;
                    if (this.showhideHowMuchMorePerMonthInput === 1) {
                        monthlyPayment = formData.morePerMonth;
                    } else {
                        timeline = formData.yearPayOff;
                    }
                    const yearsTotalMonth = 12;
                    const maxMonths = 1200; // maximum 1200 months taken mean 100 year for calculation
                    const tenUnits = 10;
                    const hundredUnits = 100;
                    const term = helperstudentloanpayoff.calculateTermsValue(formData.balanceAmount, formData.averageInterestRate, formData.loanTerm, yearsTotalMonth, hundredUnits);
                    if (!term) {
                        this.error.loanTermError = this.errorMessages.higherLoanTerm;
                        return {
                            monthlyPayment: { old: null, new: null, savings: null },
                            interest: { old: null, new: null, savings: null },
                            balanceAmount: { old: null, new: null, savings: null },
                            term: { old: null, new: null, savings: null },
                            message: this.errorMessages.higherLoanTerm,
                        };
                    }
                    const termInMonths = term * yearsTotalMonth;
                    const monthlyRate = parseFloat(formData.averageInterestRate / (yearsTotalMonth * hundredUnits));
                    const payment = formData.loanTerm;
                    const expectedTotalInterest = payment * termInMonths - formData.balanceAmount;
                    const results = {
                        balanceAmount: formData.balanceAmount,
                        rate: formData.averageInterestRate,
                        term,
                        monthlyRate,
                        monthlyPayment,
                        timeline,
                        payment,
                        termInMonths,
                        basicTotal: parseFloat(payment * termInMonths),
                        expectedTotalInterest,
                        months: [],
                        yearsTotalMonth,
                        maxMonths,
                        tenUnits,
                        hundredUnits,
                    };
                    this.showResult = timeline === 0
                        ? helperstudentloanpayoff.calculationAsPerPayExtra(results)
                        : helperstudentloanpayoff.calculationAsPerYeartoPayoff(results);
                }
                return true;
            },
        },
    };
</script>
<style src="../../assets/styles/common.scss" lang="scss"></style>
<style src="./main.scss" lang="scss"></style>
